/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Billing_Frequency_HintInputs */

const en_admin_resources_billing_frequency_hint = /** @type {(inputs: Admin_Resources_Billing_Frequency_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How often the customer is invoiced (e.g. 1 = monthly, 3 = quarterly, 12 = yearly)`)
};

const de_admin_resources_billing_frequency_hint = /** @type {(inputs: Admin_Resources_Billing_Frequency_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie oft dem Kunden eine Rechnung gestellt wird (z. B. 1 = monatlich, 3 = vierteljährlich, 12 = jährlich)`)
};

const es_admin_resources_billing_frequency_hint = /** @type {(inputs: Admin_Resources_Billing_Frequency_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con qué frecuencia se factura al cliente (por ejemplo, 1 = mensual, 3 = trimestral, 12 = anual)`)
};

const fr_admin_resources_billing_frequency_hint = /** @type {(inputs: Admin_Resources_Billing_Frequency_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fréquence de facturation du client (par exemple, 1 = mensuel, 3 = trimestriel, 12 = annuel)`)
};

/** @type {(inputs: Admin_Resources_Billing_Frequency_HintInputs) => LocalizedString} */
const it_admin_resources_billing_frequency_hint = en_admin_resources_billing_frequency_hint;

/** @type {(inputs: Admin_Resources_Billing_Frequency_HintInputs) => LocalizedString} */
const pt_br2_admin_resources_billing_frequency_hint = en_admin_resources_billing_frequency_hint;

/** @type {(inputs: Admin_Resources_Billing_Frequency_HintInputs) => LocalizedString} */
const pl_admin_resources_billing_frequency_hint = en_admin_resources_billing_frequency_hint;

/** @type {(inputs: Admin_Resources_Billing_Frequency_HintInputs) => LocalizedString} */
const hu_admin_resources_billing_frequency_hint = en_admin_resources_billing_frequency_hint;

/** @type {(inputs: Admin_Resources_Billing_Frequency_HintInputs) => LocalizedString} */
const ro_admin_resources_billing_frequency_hint = en_admin_resources_billing_frequency_hint;

/**
* | output |
* | --- |
* | "How often the customer is invoiced (e.g. 1 = monthly, 3 = quarterly, 12 = yearly)" |
*
* @param {Admin_Resources_Billing_Frequency_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_billing_frequency_hint = /** @type {((inputs?: Admin_Resources_Billing_Frequency_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Billing_Frequency_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_billing_frequency_hint(inputs)
	if (locale === "de") return de_admin_resources_billing_frequency_hint(inputs)
	if (locale === "es") return es_admin_resources_billing_frequency_hint(inputs)
	if (locale === "fr") return fr_admin_resources_billing_frequency_hint(inputs)
	if (locale === "it") return it_admin_resources_billing_frequency_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_billing_frequency_hint(inputs)
	if (locale === "pl") return pl_admin_resources_billing_frequency_hint(inputs)
	if (locale === "hu") return hu_admin_resources_billing_frequency_hint(inputs)
	return ro_admin_resources_billing_frequency_hint(inputs)
});
export { admin_resources_billing_frequency_hint as "admin.resources.billing_frequency_hint" }